import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-eula-agreement',
  templateUrl: './eula-agreement.component.html',
  styleUrls: ['./eula-agreement.component.scss']
})
export class EulaAgreementComponent {
	@Output() submitForm = new EventEmitter();

	eulaPDF = '../../assets/eula.pdf';
	zoom = 1;
	eula_checked = false;
	eulaChecked = false;
	submitted = false;

	zoomUp() {
		if (this.zoom < 3) {
			this.zoom = this.zoom + 0.5;
		}
	}

	zoomDown() {
		if (this.zoom > 1) {
			this.zoom = this.zoom - 0.5;
		}
	}
}
